<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-885.75 -854)">
			<path
				d="M39.5,15.575,26.019,14.412,20.75,2,15.481,14.431,2,15.575l10.237,8.869L9.163,37.625,20.75,30.631l11.587,6.994L29.281,24.444ZM20.75,27.125,13.7,31.381l1.875-8.025-6.225-5.4,8.213-.712L20.75,9.687l3.206,7.575,8.212.712-6.225,5.4L27.819,31.4Z"
				transform="translate(887.5 855.75)"
			/>
			<path class="a" d="M0,0H45V45H0Z" transform="translate(885.75 854)" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-star-border',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
path.a {
	fill: none;
}
</style>

<docs>
	IconStarBorder

	```js
	<b-icon-star-border />
	```
</docs>
